import React from 'react';
import { Link, LinkProps, Typography } from '@mui/material';
import { Interweave, Node } from 'interweave';

function transform(node: HTMLElement, children: Node[]) {
  if (node.tagName === 'A') {
    const { href } = node as HTMLAnchorElement;

    try {
      const url = new URL(href);
      const linkProps: LinkProps = {};

      if (window.location.hostname !== url.hostname) {
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
      }

      return (
        <Link href={url.href} {...linkProps} underline="hover">
          {children}
        </Link>
      );
    } catch {
      // when the URL is invalid, just return the text
      return <b>{children}</b>;
    }
  }

  if (node.tagName === 'H2') {
    return (
      <Typography component="h2" variant="h6">
        {children}
      </Typography>
    );
  }
}

interface HtmlToMUIMapperProps {
  content?: string | null;
}

function HtmlToMUIMapper({ content }: HtmlToMUIMapperProps) {
  return <Interweave transform={transform} content={content} />;
}

export default HtmlToMUIMapper;
